import {Avatar} from '@mui/material';
import {THEME} from '@wandb/weave/common/css/color.styles';
import {type SelectSize} from '@wandb/weave/components/Form/Select';
import styled from 'styled-components';

const VALUE_OPTION_HEIGHTS: Partial<Record<SelectSize, number>> = {
  small: 14,
  medium: 18,
  large: 26,
};

const VALUE_ICON_HEIGHTS: Partial<Record<SelectSize, number>> = {
  small: 14,
  medium: 18,
  large: 26,
};

type UserOptionProps = {
  size: SelectSize;
  isValue: boolean;
};

export const UserOption = styled.div<UserOptionProps>`
  display: flex;
  align-items: center;
  height: ${props => (props.isValue ? VALUE_OPTION_HEIGHTS[props.size] : 40)}px;
`;
UserOption.displayName = 'S.UserOption';

type AvatarImageProps = {
  size: SelectSize;
  $isValue: boolean;
};

export const AvatarImage = styled(Avatar)<AvatarImageProps>`
  && {
    width: ${props => (props.$isValue ? VALUE_ICON_HEIGHTS[props.size] : 30)}px;
    height: ${props =>
      props.$isValue ? VALUE_ICON_HEIGHTS[props.size] : 30}px;
  }
  margin-right: 8px;
  img {
    object-fit: contain;
  }
`;
AvatarImage.displayName = 'S.AvatarImage';

export const UserName = styled.span`
  margin-right: 8px;
`;
UserName.displayName = 'S.UserName';

type EnabledProps = {
  isDisabled: boolean;
};

export const UserUsername = styled.span<EnabledProps>`
  color: ${THEME.textTertiary};
  opacity: ${props => (props.isDisabled ? 0.7 : 'inherit')};
`;
UserUsername.displayName = 'S.UserUsername';

export const UserEmail = styled.div<EnabledProps>`
  font-size: 14px;
  color: ${THEME.textTertiary};
  opacity: ${props => (props.isDisabled ? 0.7 : 'inherit')};
`;
UserEmail.displayName = 'S.UserEmail';
